<template>
  <v-card
    :flat="carousel.flat||true"
    :outlined="carousel.outlined||false"
    :height="carousel.height||'300px'"
    :width="wide ? null : carousel.width||'300px'"
    tile
  >
    <v-carousel
      v-if="images && images.length > 1"
      :height="carousel.height||'300px'"
      :width="carousel.height||'300px'"
      :cycle="carousel.cycle||true"
      :continuous="carousel.continuous || false"
      :show-arrows="!$vuetify.breakpoint.mobile"
      hide-delimiter-background
    >
      <v-carousel-item
        v-for="img in images"
        :key="img"
      >
        <v-img
          height="100%"
          width="100%"
          :src="`${img}`"
        />
      </v-carousel-item>
    </v-carousel>
    <v-img
      v-else-if="images && images.length == 1"
      height="100%"
      width="100%"
      :src="`${images[0]}`"
    />
  </v-card>
</template>

<script>
export default {
  name: "Pictures",
  props: {
    images: {
      type: Array,
      default: ()=>[]
    },
    options: {
      type: Object,
      default: ()=>{return {}}
    },
    wide: {
      type: Boolean
    },
    small: {
      type: Boolean
    }
  },
  computed: {
    carousel(){return this.options || {}},
  }
}
</script>

<style scoped>

.v-card {
  display: flex !important;
  flex-direction: column;
}

</style>